/* eslint-disable */
import viewData from './viewData.js'

import { getDistrict } from '../api.js'

import cache from '../cache.js'

const CACHE_PATH_CODE = ['district', 'codes']
const CACHE_PATH_DATA = ['district', 'data']
const CACHE_TIME = 15 * 60 * 1000 // 15 minutes

const _vars = {
  data: undefined,
  apiPromise: undefined,
}

// function _getAllCodes() {
//   cache.checkGetMiss(CACHE_PATH_CODE, () => {
//     return getDistrict()
//       .then(response => {
//         cache.set(response.data, CACHE_TIME, ...CACHE_PATH_CODE)
//         return response.data
//       })
//   })
// }

// function _getDistrict(code) {
//   if (code === undefined) {
//     return cache.checkGetMiss(CACHE_PATH_DATA, () => {
//       return getDistrict(/*{ fields: 'all' }*/)
//         .then(response => {
//           cache.set(response.data, CACHE_TIME, ...CACHE_PATH_DATA)
//           return response.data
//         })
//     })
//   }
//   else {
//     return cache.checkGetMiss([...CACHE_PATH_DATA, code], () => {
//       return getDistrict(/*{ codes: [code], fields: 'all' }*/)
//         .then(response => {
//           cache.set(response.data, CACHE_TIME, ...CACHE_PATH_DATA, code)
//           return response.data
//         })
//     })
//   }
// }

function populate(data) {
  // cache.set(data, CACHE_TIME, ...CACHE_PATH_DATA)
  _vars.data = data
}

function getSync(id) {
  if (_vars.data === undefined) {
    return undefined
  }
  return _vars.data.find(elem => elem.id === id)
}

function get(id) {
  // cache.checkGetMiss(CACHE_PATH_DATA, () => {
  //   return viewData.getOptionsFromServer()
  // })
  let retPromise = undefined
  if (_vars.data === undefined) {
    _vars.viewPromise = viewData.getOptionsFromServer()

    retPromise = _vars.viewPromise.then(() => {
      return _vars.data.find(elem => elem.id === id)
    })
  }
  else {
    retPromise = Promise.resolve(getSync(id))
  }
  return retPromise
}

function filter(filterIds) {
  let retPromise = undefined
  if (_vars.data === undefined) {
    _vars.viewPromise = viewData.getOptionsFromServer()

    retPromise = _vars.viewPromise.then(() => {
      return _vars.data.filter(elem => filterIds.includes(elem.id))
    })
  }
  else {
    retPromise = Promise.resolve(_vars.data.filter(elem => filterIds.includes(elem.id)))
  }
  return retPromise
}

export default {
  // getAllCodes: _getAllCodes,
  // getDistrict: _getDistrict,
  populate: populate,
  getSync: getSync,
  get: get,
  filter: filter,
}
